import React from 'react';

/**
 * Horizontal strip of screenshot thumbnails for one project.
 * Renders nothing when the project has no screenshots. Clicking a thumbnail
 * reports its index so the parent can open it in the Lightbox.
 * Styled by .gallery / .gallery-thumb in styles/app.css, skinned per view
 * through body.pro-view / body.terminal-view.
 */
const ProjectGallery = ({ images, onOpen }) => {
  if (!images || images.length === 0) return null;
  return (
    <div className="gallery">
      {images.map((img, i) => (
        <button
          key={img.src}
          type="button"
          className="gallery-thumb"
          aria-label={`Open screenshot ${i + 1} of ${images.length}: ${img.alt}`}
          onClick={() => onOpen(i)}
        >
          {/* width/height give the browser the aspect ratio before the lazy image loads,
              so the strip is laid out at its final size with no shift. */}
          <img src={img.src} alt={img.alt} width={img.w} height={img.h} loading="lazy" decoding="async" />
        </button>
      ))}
    </div>
  );
};

export default ProjectGallery;
